exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".message-instead-result {\n    text-align: center;\n    margin: 24px;\n    font-size: 1.6em;\n    font-weight: bold;\n    padding: 24px 0;\n    opacity: 0.4;\n    background: #FFFFAA;\n    border-radius: 3px;\n    border: 1px solid #443300;\n}\n\n.message-instead-result-loading {\n    text-align: center;\n    margin: 24px;\n    font-size: 1.6em;\n    font-weight: bold;\n    padding: 24px 0;\n    opacity: 0.4;\n}\n\ntd[left-text] {\n    text-align: left;\n}\n\ntr[point-exer].l-inactive-item {\n    cursor: default;\n    background: #FFCCCC;\n    opacity: 0.7;\n}\n\n.fa.fa-recycle {\n    color: #353b16;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/leads/global-search/global-search.component.css
// module id = 1220
// module chunks = 9